<template>
  <div class="member-page">
    <common-header />
    <div class="member-body">
      <div class="text-21-color text-bold flex justify-between align-center">
        <span class="text-28">会员中心</span>
        <span
          class="text-14"
          style="cursor: pointer"
          @click="showOrderDetailDialog"
          >充值记录</span
        >
      </div>
      <section class="flex">
        <div
          class="profile-card-box w-253 h-382 bg-white text-center padding-top-30 radius-20"
        >
          <img
            class="w-73 h-73 radius-50"
            :src="userInfo.avatar || require('@/assets/images/login.png')"
            alt="avatar"
          />
          <p class="padding-tb-10">{{ userInfo.nickname }}</p>
          <p class="text-main text-bold" v-if="!userInfo.is_member">
            开通会员即刻投稿
          </p>
          <div v-if="userInfo.is_member">
            会员到期时间：{{ userInfo.member_expire_time_text }}
          </div>
          <el-button
            type="primary"
            round
            class="plan-btn1"
            @click="showRedeemDialog"
          >
            兑换码</el-button
          >
        </div>
        <div
          class="plan-card-box w-927 bg-white padding-25 margin-left-20 radius-20"
        >
          <p class="plan-title">选择套餐</p>
          <div class="flex justify-around">
            <div
              v-for="plan in plans"
              :key="plan.id"
              :class="['plan-box', { active: plan.id === activePlan }]"
              @click="handleActivePlan(plan)"
            >
              <p class="padding-bottom-30">{{ plan.name }}</p>
              <p class="text-26">¥ {{ plan.price }}</p>
              <small v-if="plan.tag" class="plan-tag">{{ plan.tag }}</small>
            </div>
          </div>
          <el-button
            type="primary"
            round
            class="plan-btn"
            @click="showPaymentDialog"
            >立即开通</el-button
          >
        </div>
      </section>

      <section class="member-desc">
        <p class="text-bold">会员说明</p>
        <p class="padding-top-30 text-14 text-21-color">
          {{ obj.description }}
        </p>
      </section>
    </div>

    <!-- 支付方式选择弹窗 -->
    <el-dialog
      :visible.sync="paymentDialogVisible"
      width="460px"
      custom-class="payment-dialog"
      :show-close="false"
    >
      <template #title>
        <div class="text-center text-21-color text-bold text-28 padding-top-30">
          选择支付方式
        </div>
      </template>
      <div class="payment-options margin-lr-40">
        <div
          v-for="method in paymentMethods"
          :key="method.id"
          :class="['payment-option', { active: selectedPayment === method.id }]"
          @click="handlePaymentMethodSelect(method.id)"
        >
          <div class="text-000-color text-bold">{{ method.name }}</div>
          <div class="payment-icon margin-top-30">
            <img :src="method.icon" :alt="method.name" />
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 充值订单弹窗 -->
    <el-dialog
      :visible.sync="orderDialogVisible"
      width="420px"
      top="20vh"
      custom-class="order-dialog"
      :show-close="false"
    >
      <template #title>
        <div class="dialog-title-wrapper padding-top-30">
          <div
            class="text-center text-21-color text-bold text-28 padding-bottom-30"
          >
            充值订单
          </div>
          <div class="close-btn" @click="orderDialogVisible = false">
            <img :src="closeIcon" alt="关闭" />
          </div>
        </div>
      </template>
      <div class="padding-bottom-30">
        <div class="text-21-color padding-left-30">
          <p class="">订单号: {{ orderNumber }}</p>
          <p class="padding-top-12">支付方式: {{ selectedPaymentMethod }}</p>
        </div>
        <div class="padding-top-30 flex flex-direction align-center">
          <div class="qr-code">
            <img :src="qrCodeUrl" alt="支付二维码" />
          </div>
          <p class="padding-top-16 text-14 text-999-color">
            支付完成后请刷新页面查看会员状态。
          </p>
        </div>
      </div>
    </el-dialog>
    <!-- 充值订单详情弹窗 -->
    <el-dialog
      :visible.sync="orderDetailDialogVisible"
      width="574px"
      custom-class="order-detail-dialog"
      :show-close="false"
    >
      <div class="order-detail-dialog-wrapper">
        <div class="order-detail-tabs padding-lr-30">
          <div class="flex justify-around align-center">
            <div
              v-for="(item, index) in list"
              :key="index"
              :class="['tab-item', { active: activeTab === index }]"
              @click="handleTabChange(index)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="order-detail-scroll-view">
          <div class="padding-lr-30 padding-bottom-30">
            <div v-if="orderRecords.length === 0" class="empty-state">
              <div class="empty-icon">
                <i class="el-icon-document"></i>
              </div>
              <div class="empty-text">暂无记录</div>
              <div class="empty-desc">当前筛选条件下没有找到相关记录</div>
            </div>
            <div
              class="order-detail-content margin-top-20 padding-20 radius-20"
              v-for="(item, index) in orderRecords"
              :key="index"
            >
              <div class="order-detail-item">
                <span class="order-label">订单号：</span>
                <span class="order-value">{{
                  item.orderNumber || item.order_no || item.id
                }}</span>
              </div>
              <div class="order-detail-item padding-tb-15">
                <span class="order-label">充值类型：</span>
                <span class="order-value">{{
                  item.rechargeType || item.card_name || item.name || "会员套餐"
                }}</span>
              </div>
              <div class="order-detail-item">
                <span class="order-label">充值商品：</span>
                <span class="order-value">{{
                  item.product || item.card_name || item.name || "会员套餐"
                }}</span>
              </div>
              <div class="order-detail-item padding-tb-15">
                <span class="order-label">充值时间：</span>
                <span class="order-value">{{
                  item.rechargeTime || item.create_time || item.created_at || ""
                }}</span>
              </div>
              <div class="order-detail-item">
                <span class="order-label">充值状态：</span>
                <span
                  class="order-value status-text"
                  :class="getStatusClass(item.payment_status || item.status)"
                >
                  {{ getStatusText(item.payment_status || item.status) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 兑换码弹窗 -->
    <el-dialog
      :visible.sync="redeemDialogVisible"
      width="420px"
      custom-class="redeem-dialog"
      :show-close="false"
    >
      <template #title>
        <div class="dialog-title-wrapper padding-top-30">
          <div
            class="text-center text-21-color text-bold text-28 padding-bottom-20"
          >
            兑换码
          </div>
          <div class="close-btn" @click="closeRedeemDialog">
            <img :src="closeIcon" alt="关闭" />
          </div>
        </div>
      </template>
      <div class="padding-lr-30 padding-bottom-30">
        <el-input
          v-model.trim="redeemCode"
          placeholder="请输入兑换码"
          clearable
        />
        <div class="flex justify-center margin-top-20">
          <el-button
            type="primary"
            round
            class="plan-btn"
            :loading="redeemLoading"
            @click="handleRedeemCode"
          >
            立即兑换
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue";
import {
  getMemberPackages,
  getMemberRecords,
  createMemberOrder,
  redeemMemberCode,
} from "@/api/member";
import { getUserInfo } from "@/api/user";

export default {
  name: "Member",
  components: { CommonHeader },
  data() {
    return {
      activePlan: null,
      plans: [],
      paymentDialogVisible: false,
      redeemDialogVisible: false,
      orderDialogVisible: false,
      orderDetailDialogVisible: false,
      redeemCode: "",
      redeemLoading: false,
      selectedPayment: "wechat",
      orderNumber: "",
      obj: {},
      userInfo: {}, // 用户信息
      userInfoLoading: false, // 用户信息加载状态
      paymentMethods: [
        {
          id: "wechat",
          name: "微信",
          icon: require("@/assets/images/icon8.png"),
        },
        {
          id: "alipay",
          name: "支付宝",
          icon: require("@/assets/images/icon9.png"),
        },
        {
          id: "balance",
          name: "余额支付",
          icon: require("@/assets/images/icon16.png"),
        },
      ],
      orderDetail: [],
      orderRecords: [], // 订单记录列表
      qrCodeUrl:
        "https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=payment",
      closeIcon: require("@/assets/images/icon10.png"),
      activeTab: 0,
      list: [
        {
          name: "全部",
          payment_status: "",
        },
        {
          name: "待支付",
          payment_status: "pending",
        },
        {
          name: "支付失败",
          payment_status: "failed",
        },
        {
          name: "支付成功",
          payment_status: "paid",
        },
      ],
    };
  },
  mounted() {
    this.fetchUserInfo();
    this.fetchMemberPackages();
  },
  computed: {
    selectedPaymentMethod() {
      const method = this.paymentMethods.find(
        (m) => m.id === this.selectedPayment
      );
      return method ? method.name : "微信";
    },
  },
  methods: {
    showRedeemDialog() {
      this.redeemDialogVisible = true;
    },
    closeRedeemDialog() {
      this.redeemDialogVisible = false;
      this.redeemCode = "";
    },
    handleRedeemCode() {
      if (!this.redeemCode) {
        this.$message.warning("请输入兑换码");
        return;
      }
      this.redeemLoading = true;
      redeemMemberCode({
        code: this.redeemCode,
      })
        .then((response) => {
          this.$message.success(response.msg || "兑换成功");
          this.closeRedeemDialog();
          // 刷新用户信息，更新会员状态与到期时间
          this.fetchUserInfo();
        })
        .catch((error) => {
          this.$message.error(error.message || "兑换失败，请稍后重试");
        })
        .finally(() => {
          this.redeemLoading = false;
        });
    },
    // 获取用户信息
    fetchUserInfo() {
      // 先从 localStorage 获取基本信息作为默认值
      const savedUserInfo = localStorage.getItem("userInfo");
      if (savedUserInfo) {
        try {
          const info = JSON.parse(savedUserInfo);
          this.userInfo.avatar =
            info.avatar || (info.userinfo && info.userinfo.avatar) || "";
          this.userInfo.nickname =
            info.nickname ||
            (info.userinfo && info.userinfo.nickname) ||
            info.username ||
            "";
        } catch (e) {
          console.error("解析用户信息失败:", e);
        }
      }

      // 调用接口获取完整的用户信息
      this.userInfoLoading = true;
      getUserInfo()
        .then((response) => {
          this.userInfoLoading = false;
          if (response.data) {
            this.userInfo = response.data;
          }
        })
        .catch((error) => {
          this.userInfoLoading = false;
          // 401 错误已经在拦截器中处理了跳转，这里只处理其他错误
          if (error.message && !error.message.includes("请登录后操作")) {
            console.error("获取用户信息失败:", error);
          }
        });
    },
    handleActivePlan(plan) {
      this.activePlan = plan.id;
      this.obj = plan;
    },
    // 获取会员套餐列表
    fetchMemberPackages() {
      getMemberPackages({
        page: "1",
        limit: "10",
      }).then((response) => {
        // 根据接口返回的数据结构调整
        if (response.data && response.data.list) {
          this.plans = response.data.list.map((item) => ({
            id: item.id || item.card_id,
            name: item.name || item.card_name || "",
            price: item.price || item.amount || 0,
            tag: item.tag || item.label || "",
            description: item.description,
          }));
          // 默认选中第一个套餐
          if (this.plans.length > 0 && !this.activePlan) {
            this.activePlan = this.plans[0].id;
            this.obj = this.plans[0];
          }
        }
      });
    },
    showPaymentDialog() {
      this.paymentDialogVisible = true;
    },
    // 处理支付方式选择并下单
    handlePaymentMethodSelect(methodId) {
      // 设置选中的支付方式
      this.selectedPayment = methodId;
      // 检查是否已选择套餐
      if (!this.activePlan && !this.obj.id) {
        this.$message.warning("请先选择套餐");
        return;
      }
      // 获取套餐ID
      const packageId = this.activePlan || this.obj.id;
      if (!packageId) {
        this.$message.warning("套餐信息异常，请刷新后重试");
        return;
      }
      // 调用下单接口
      createMemberOrder({
        package_id: packageId,
        payment_method: methodId, // 使用字符串格式，如 'wechat' 或 'alipay'
      }).then((response) => {
        this.$message.success("订单创建成功");
        this.paymentDialogVisible = false;
        const res = response.data;
        if (!res) return;
        this.orderNumber = res.order_no || res.order_number || "";

        // 支付跳转逻辑：
        // - 微信/支付宝：展示二维码弹窗，用户扫码支付
        // - 余额支付：按后端返回结果处理（通常直接支付成功）
        const payType = res.pay_type || methodId;
        const payData = res.pay_data || {};
        const qrCodeUrl =
          payData.qr_code_url || payData.pay_url || payData.qr_code;

        if (payType === "wechat" || payType === "alipay") {
          if (qrCodeUrl) {
            this.qrCodeUrl = qrCodeUrl;
          }
          this.orderDialogVisible = true;
          return;
        }

        if (payType === "balance") {
          this.orderDialogVisible = false;
          this.$message.success(response.msg || "余额支付成功");
          window.location.reload();
          return;
        }

        if (payData.pay_url) {
          window.location.href = payData.pay_url;
        } else {
          this.orderDialogVisible = true;
        }
      });
    },
    // 显示充值订单详情弹窗
    showOrderDetailDialog() {
      this.orderDetailDialogVisible = true;
      this.activeTab = 0;
      this.fetchMemberRecords("");
    },
    // 切换 tab
    handleTabChange(index) {
      this.activeTab = index;
      const paymentStatus = this.list[index].payment_status;
      this.fetchMemberRecords(paymentStatus);
    },
    // 获取会员购买记录
    fetchMemberRecords(paymentStatus) {
      getMemberRecords({
        payment_status: paymentStatus,
      }).then((response) => {
        // 根据接口返回的数据结构调整
        if (response.data && response.data.list) {
          this.orderRecords = response.data.list.map((item) => ({
            orderNumber: item.order_no || item.order_number || item.id,
            rechargeType: item.card_name || item.name || "会员套餐",
            product: item.card_name || item.name || "会员套餐",
            rechargeTime: this.formatTime(
              item.create_time || item.created_at || item.createtime
            ),
            payment_status: item.payment_status || item.status,
            ...item, // 保留原始数据
          }));
        }
      });
    },
    // 格式化时间
    formatTime(timestamp) {
      if (!timestamp) return "";
      // 如果是时间戳（秒），转换为毫秒
      const time =
        typeof timestamp === "number" && timestamp < 10000000000
          ? timestamp * 1000
          : timestamp;
      const date = new Date(time);
      if (isNaN(date.getTime())) return timestamp; // 如果无法解析，返回原值
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        pending: "待支付",
        paid: "支付成功",
        failed: "支付失败",
        success: "支付成功",
        0: "待支付",
        1: "支付成功",
        2: "支付失败",
      };
      return statusMap[status] || status || "未知状态";
    },
    // 获取状态样式类
    getStatusClass(status) {
      const classMap = {
        pending: "status-pending",
        paid: "status-success",
        failed: "status-failed",
        success: "status-success",
        0: "status-pending",
        1: "status-success",
        2: "status-failed",
      };
      return classMap[status] || "";
    },
  },
};
</script>

<style scoped lang="scss">
.member-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #fff6f8 0%, #f3f7ff 100%);
}

.member-body {
  max-width: 1200px;
  margin: 20px auto 60px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.profile-card,
.plan-card,
.member-desc {
  background: #fff;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 12px 30px rgba(31, 46, 134, 0.08);
}

.profile-card {
  text-align: center;
}

.profile-card-box {
  transition: all 0.3s ease;
  cursor: default;
  box-shadow: 0 12px 30px rgba(31, 46, 134, 0.08);
}

.profile-card-box:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(31, 46, 134, 0.15);
}

.avatar {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 16px;
}

.phone {
  font-size: 18px;
  margin: 0;
  color: #333;
}

.tips {
  color: #ff6c88;
  margin-top: 6px;
}

.plan-card-box {
  transition: all 0.3s ease;
  box-shadow: 0 12px 30px rgba(31, 46, 134, 0.08);
}

.plan-card-box:hover {
  box-shadow: 0 16px 40px rgba(31, 46, 134, 0.12);
}

.plan-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.plan-row {
  display: flex;
}

.plan-box {
  border-radius: 20px;
  background: #fef2f4;
  color: #000;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 242px;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-weight: bold;
  position: relative;
  overflow: hidden;
}

.plan-box::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(255, 108, 136, 0.1) 0%,
    rgba(216, 90, 112, 0.1) 100%
  );
  opacity: 0;
  transition: opacity 0.3s ease;
}

.plan-box:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 8px 24px rgba(255, 108, 136, 0.25);
  background: #ffeef1;
}

.plan-box:hover::before {
  opacity: 1;
}

.plan-box.active {
  background: #ff6c88;
  color: #fff !important;
  box-shadow: 0 4px 16px rgba(255, 108, 136, 0.4);
}

.plan-box.active:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 8px 24px rgba(255, 108, 136, 0.5);
  background: #ff5a7a;
}

.plan-box.active .plan-price {
  color: #fff;
}

.plan-tag {
  margin-top: 6px;
  display: inline-block;
  color: #fff;
}

.plan-btn1 {
  background: #d85a70;
  border: none;
  margin-top: 20px;
}

.plan-btn {
  display: block;
  margin: 34px auto 0;
  border: none;
  width: 345px;
  height: 46px;
  background: #d85a70;
  border-radius: 57px;
}

.member-desc {
  min-height: 180px;
  background: #fff;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 12px 30px rgba(31, 46, 134, 0.08);
  transition: all 0.3s ease;
  cursor: default;
}

.member-desc:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 40px rgba(31, 46, 134, 0.12);
}

.member-desc h3 {
  margin-top: 0;
  margin-bottom: 12px;
}

/* 支付弹窗样式 */
.payment-dialog ::v-deep .el-dialog {
  border-radius: 12px;
}

.payment-options {
  display: flex;
  justify-content: space-around;
  gap: 20px;
  padding: 20px 0;
}

.payment-option {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
}

.payment-option:hover {
  border-color: #d85a70;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(216, 90, 112, 0.15);
}

.payment-icon {
  width: 80px;
  height: 74px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.payment-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.dialog-btn {
  border-radius: 57px;
  width: 158px;
  height: 46px;
}

.dialog-btn.ghost {
  color: #d85a70;
  border-color: #d85a70;
}

.dialog-btn.solid {
  background: #d85a70;
  border-color: #d85a70;
}

/* 充值订单弹窗样式 */
.order-dialog ::v-deep .el-dialog {
  border-radius: 12px;
}

::v-deep .el-dialog__header {
  border-bottom: none;
  padding: 0;
  position: relative;
}

.dialog-title-wrapper {
  position: relative;
  width: 100%;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: #e0e0e0;
  transform: scale(1.1);
}

.close-btn img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.order-text {
  font-size: 16px;
  color: #333;
  margin: 0 0 12px 0;
  text-align: left;
}

.order-text:last-child {
  margin-bottom: 0;
}

.qr-code {
  width: 240px;
  height: 240px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.qr-code img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

::v-deep {
  .el-dialog {
    border-radius: 12px;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.order-detail-content {
  border: 1px solid #dddddd;
}

.tab-item {
  cursor: pointer;
  padding: 8px 16px;
  transition: color 0.3s;
  color: #333;
}

.tab-item:hover {
  color: #d85a70;
}

.tab-item.active {
  color: #d85a70;
  font-weight: 600;
  position: relative;
}

/* 充值订单详情弹窗滚动样式 */
.order-detail-dialog ::v-deep .el-dialog__body {
  padding: 0;
  max-height: 70vh;
  display: flex;
  flex-direction: column;
}

.order-detail-dialog-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 70vh;
}

.order-detail-tabs {
  flex-shrink: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.order-detail-scroll-view {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.order-detail-scroll-view::-webkit-scrollbar {
  width: 6px;
}

.order-detail-scroll-view::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.order-detail-scroll-view::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.order-detail-scroll-view::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 订单状态样式 */
.status-text {
  font-weight: 500;
}

.status-text.status-success {
  color: #28b74a;
}

.status-text.status-pending {
  color: #ff9800;
}

.status-text.status-failed {
  color: #ff4d4f;
}

/* 空状态样式 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  min-height: 300px;
}

.empty-icon {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: linear-gradient(135deg, #fff6f8 0%, #f3f7ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  position: relative;
}

.empty-icon::before {
  content: "";
  position: absolute;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: rgba(216, 90, 112, 0.08);
  animation: pulse 2s ease-in-out infinite;
}

.empty-icon i {
  font-size: 48px;
  color: #d85a70;
  position: relative;
  z-index: 1;
  opacity: 0.6;
}

.empty-text {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.empty-desc {
  font-size: 14px;
  color: #999;
  line-height: 1.5;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
}
</style>
